import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixFunctionsEditorfunctionsV1EditorFunctionsUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {};

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_functions_editor-functions';

/** Invokes the specified Editor Function. Returns a NOT_FOUND error if editor function can't be found by the provided id. */
export function invokeEditorFunction(
  payload: object
): RequestOptionsFactory<any> {
  function __invokeEditorFunction({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.functions.v1.editor_function',
      method: 'POST' as any,
      methodFqn:
        'wix.functions.editorfunctions.v1.EditorFunctions.InvokeEditorFunction',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFunctionsEditorfunctionsV1EditorFunctionsUrl({
        protoPath: '/v1/editor-functions/{functionId}/invoke',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __invokeEditorFunction;
}
